module.exports = __webpack_public_path__ + "static/media/hyerim-jeong-new.14e796d9.png";